import { render } from "./LetterTile.vue?vue&type=template&id=f879c156&scoped=true&ts=true"
import script from "./LetterTile.vue?vue&type=script&lang=ts"
export * from "./LetterTile.vue?vue&type=script&lang=ts"

import "./LetterTile.vue?vue&type=style&index=0&id=f879c156&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f879c156"]])

export default __exports__